import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Ajce Hostel App React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Ajce Hostel App React base styles
import breakpoints from "assets/theme/base/breakpoints";

import MDButton from "components/MDButton";
import MuiLink from "@mui/material/Link";
import { useMaterialUIController } from "context";

import { Link } from "react-router-dom";

function Header({ children, item }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [MUIController] = useMaterialUIController();

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const profileData = {
    name: item.name,
    admissionNo: item.admissionNo,
    guardianMob: item.guardianMob,
  };

  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="5rem"
        borderRadius="xl"
      />
      <Card
        sx={{
          position: "relative",
          mt: -8,
          mx: 0,
          py: 2,
          px: 2,
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar src={item.imgLink} alt="profile-image" size="xl" shadow="sm" />
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {profileData.name}
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular">
                {profileData.admissionNo}
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6} marginLeft={"auto"}>
            <AppBar
              position="static"
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              <Link
                to={`/students/edit/${profileData.admissionNo}`}
                style={{ marginRight: "1rem", width: "100%" }}
              >
                <MDButton fullWidth color={MUIController.sidenavColor} variant="gradient">
                  Edit Profile
                </MDButton>
              </Link>

              <MuiLink href={`tel:${profileData.guardianMob}`} style={{ width: "100%" }}>
                <MDButton fullWidth color="success" variant="gradient">
                  call guardian
                </MDButton>
              </MuiLink>
            </AppBar>
          </Grid>
        </Grid>
        {children}
      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
